export const tipsLog1 = require("./../../assets/images/javascript.png");
export const tipsLog2 = require("./../../assets/images/angular.png");
export const tipsLog3 = require("./../../assets/images/react copy.png");
export const tipsLog4 = require("./../../assets/images/css.png");
export const tipsLog5 = require("./../../assets/images/rxjs.png");
export const tipsLog6 = require("./../../assets/images/images.png");
export const tipsLog7 = require("./../../assets/images/next.png")
export const tipsLog8 = require("./../../assets/images/node.png")
export const tipsLog9 = require("./../../assets/images/mon.png")
export const tipsLog10 = require("./../../assets/images/Figma...png");
export const tipsLog11 = require("./../../assets/images/aws.png");
export const tipsLog12 = require("./../../assets/images/e.png");
export const tipsLog13 = require("./../../assets/images/d.png");
export const tipsLog14 = require("./../../assets/images/java..jpg");
export const tipsLog15 = require("./../../assets/images/py.png");
export const tipsLog16 = require("./../../assets/images/b.png");
export const tipsLog17 = require("./../../assets/images/g.png");